import React from 'react';
import * as Icons from 'lucide-react';
import { Leaf, Users, Gem, Quote } from 'lucide-react';
import { DEFAULT_SITE_CONTENT, mergeContent } from '@/constants/defaultSiteContent';

const CommunityBanner = ({ content }) => {
  const c = mergeContent(DEFAULT_SITE_CONTENT.community, content || {});
  const fallbacks = [Leaf, Users, Gem];
  const pillars = c.pillars || [];

  return (
    <section id="community" className="relative overflow-hidden">
      <img src={c.bg_image_url} alt="" aria-hidden="true" loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0F2E23]/95 via-[#0F2E23]/80 to-[#5A3B26]/35" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />

      <div className="relative max-w-[1360px] mx-auto px-4 sm:px-6 py-14 sm:py-24 grid md:grid-cols-[1.15fr_auto] gap-8 md:gap-10 items-center">
        <div className="text-[#F5F0E6]">
          <Quote className="w-8 h-8 sm:w-9 sm:h-9 text-[#F5C86A] mb-3 sm:mb-4" />
          <div className="font-display text-[26px] sm:text-[44px] leading-[1.08] tracking-wide">
            {c.heading_line1}<br/>
            {c.heading_line2}<br/>
            {c.heading_line3}&nbsp;<span style={{ fontFamily: 'Great Vibes, cursive' }} className="italic text-[#F5C86A] normal-case">{c.heading_script}</span>
          </div>
          <p className="mt-4 sm:mt-5 max-w-md text-[13px] sm:text-sm text-[#F5F0E6]/80 leading-relaxed">{c.body}</p>
        </div>
        <div className="grid grid-cols-3 gap-4 sm:gap-8 md:gap-12 text-[#F5F0E6] md:justify-end">
          {pillars.map((p, i) => {
            const IconComp = Icons[p.icon] || fallbacks[i] || Leaf;
            return <Pillar key={i} icon={IconComp} title={p.title} sub={p.sub} />;
          })}
        </div>
      </div>
    </section>
  );
};

const Pillar = ({ icon: Icon, title, sub }) => (
  <div className="text-center min-w-0">
    <span className="inline-flex w-10 h-10 sm:w-12 sm:h-12 items-center justify-center rounded-full bg-[#F5C86A]/10 border border-[#F5C86A]/40 mb-2 sm:mb-3">
      <Icon className="w-4 h-4 sm:w-5 sm:h-5 text-[#F5C86A]" strokeWidth={1.6} />
    </span>
    <div className="text-[9px] sm:text-[10px] tracking-[0.24em] sm:tracking-[0.28em] font-semibold">{title}</div>
    <div className="text-[9px] sm:text-[10px] tracking-[0.24em] sm:tracking-[0.28em] font-semibold text-[#F5F0E6]/70">{sub}</div>
  </div>
);

export default CommunityBanner;
